import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["popover"]
  static values = {
    content: String
  }
  connect() {
  }
  copy() {
    navigator.clipboard.writeText(this.contentValue)

    // Show popover
    this.popoverTarget.classList.remove("hidden")

    // Hide after delay
    setTimeout(() => {
      this.popoverTarget.classList.add("hidden")
    }, 1000)
  }
}
